import styled from 'styled-components';

import BodyText from '@ui/atoms/BodyText';
import Eyebrow from '@ui/atoms/Eyebrow';

import theme from '@theme/WsTheme';

export const FooterLinkColumn = styled.div`
	display: flex;
	flex-flow: column;

	& > button {
		margin-bottom: 1.5rem;

		@media ${theme.responsive.breakpoints.tablet} {
			display: contents;
		}
	}

	${Eyebrow} {
		align-items: center;
		display: flex;
		font-size: 1.4rem;
		justify-content: space-between;
		text-transform: uppercase;

		@media ${theme.responsive.breakpoints.tablet} {
			margin-bottom: 1.5rem;
			svg {
				display: none;
			}
		}
	}

	a {
		text-decoration: none;

		${BodyText} {
			font-size: ${theme.fontSizes.body.sm};
			line-height: 2.4rem;
		}
	}

	a + a {
		margin-top: 1.2rem;
	}

	.linksWrapper {
		display: none;
		margin-bottom: 3rem;

		@media ${theme.responsive.breakpoints.tablet} {
			display: block;
		}

		&.collapsed {
			display: block;
		}
	}
`;

export const StyledStaticLink = styled.a`
	display: block;
	font-size: 1.6rem;
	line-height: 1.5;
	margin-bottom: 0.5rem;

	&:hover {
		text-decoration: underline;
		text-decoration-color: ${theme.colors.black};
	}

	> * {
		color: ${theme.colors.black};
		font-size: ${theme.fontSizes.body.sm};
		line-height: ${theme.lineHeights.body.sm};
	}
`;
